import FetchFactory, {
	DeleteRequest,
	GetRequest,
	ModifyRequest
} from "utils/fetch/FetchRequest";

import { Create, Overview, Update } from "./OrganisationUserTypes";

const ENDPOINT = "/api/organisations";
const USERS_SUFFIX = "users";

export default class OrganisationUserClient {
	public static getAll(orgId: number): GetRequest<Array<Overview>> {
		return FetchFactory.get(`${ENDPOINT}/${orgId}/${USERS_SUFFIX}`);
	}

	public static create(
		orgId: number,
		data: Create
	): ModifyRequest<Create, Overview> {
		return FetchFactory.post(`${ENDPOINT}/${orgId}/${USERS_SUFFIX}`, data);
	}

	public static update(
		orgId: number,
		userId: number,
		data: Update
	): ModifyRequest<Update, Overview> {
		return FetchFactory.put(
			`${ENDPOINT}/${orgId}/${USERS_SUFFIX}/${userId}`,
			data
		);
	}

	public static delete(orgId: number, userId: number): DeleteRequest<void> {
		return FetchFactory.del(
			`${ENDPOINT}/${orgId}/${USERS_SUFFIX}/${userId}`
		);
	}
}
